import { render, staticRenderFns } from "./CountryDD.vue?vue&type=template&id=2097e828"
import script from "./CountryDD.vue?vue&type=script&lang=js"
export * from "./CountryDD.vue?vue&type=script&lang=js"
import style0 from "./CountryDD.vue?vue&type=style&index=0&id=2097e828&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports